import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Grid, Paper, styled } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import { SubText as SuperText, H5 as Title, Label2 as SubText, Overline, Text, } from '../../atoms/typography';
import Button from '../../atoms/Button';
import ImageWithZoom from '../../molecules/ImageWithZoom';
const Container = styled(Grid) `
  direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const CheckboxContainer = styled(Grid) `
  align-items: center;
  width: fit-content;
  cursor: pointer;
`;
const PropertiesCard = ({ allProperties, enableNotListed, image, listedProperties, onSelectionChange, selections, showErrors, subTitle, superTitle, title, propertiesToDisableNotListedCheckbox = [], }) => {
    const [properties, setProperties] = useState(listedProperties);
    useEffect(() => {
        if (!allProperties)
            return;
        const newProperties = Object.keys(listedProperties)
            .reduce((acc, key) => ({
            ...acc,
            [key]: (selections[key]?.isNotListedChecked) ?
                [...allProperties[key].filter(value => !listedProperties[key].includes(value))] :
                [...listedProperties[key]],
        }), {});
        setProperties(newProperties);
    }, [selections, allProperties]);
    const fullWidth = Object.keys(listedProperties).length === 1;
    const colCount = fullWidth ? 12 : 6;
    const handleSelection = (property, value) => {
        const isSelected = selections[property]?.value === value;
        const newValue = isSelected ? undefined : value;
        const newSelection = {
            ...selections[property],
            value: newValue,
        };
        onSelectionChange({ ...selections, [property]: newSelection });
    };
    const handleNotFound = (property) => {
        if (!selections[property])
            return;
        const isNotFoundChecked = selections[property].isNotFoundChecked;
        const newSelection = {
            ...selections[property],
            value: undefined,
            isNotFoundChecked: !isNotFoundChecked,
        };
        onSelectionChange({ ...selections, [property]: newSelection });
    };
    const handleNotListed = (property) => {
        const isNotListedChecked = selections[property].isNotListedChecked;
        const newSelection = {
            ...selections[property],
            value: undefined,
            isNotListedChecked: !isNotListedChecked,
        };
        onSelectionChange({ ...selections, [property]: newSelection });
    };
    const propertiesContent = Object.entries(properties).map(([propertyName, propertyValues]) => {
        const { isNotFoundChecked, isNotListedChecked } = selections[propertyName];
        const capitalizedName = propertyName.charAt(0).toUpperCase() + propertyName.slice(1).toLowerCase();
        let finalPropertyValues = propertyValues;
        if (isNotListedChecked) {
            finalPropertyValues = allProperties?.[propertyName]?.filter(value => !listedProperties[propertyName].includes(value)) || [];
        }
        const buttons = finalPropertyValues.map((value) => {
            const isSelected = selections[propertyName].value === value;
            return (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: fullWidth ? 2 : 4, children: _jsx(Button, { onClick: () => handleSelection(propertyName, value), size: 'large', variant: isSelected ? 'contained' : 'outlined', startIcon: isSelected && _jsx(CheckIcon, {}), className: isSelected ? 'checked' : 'unchecked', disabled: isNotFoundChecked, value: value, fullWidth: true, label: value, parent: propertyName }) }, value));
        });
        const hasError = showErrors && !selections[propertyName].value && !isNotFoundChecked;
        const color = hasError ? 'error.main' : 'text.secondary';
        const errorMessage = hasError && (_jsx(Grid, { item: true, paddingTop: 0, children: _jsx(Text, { fontSize: '0.75rem', color: 'error.main', children: `Select a ${propertyName}` }) }));
        const showNotListedCheckbox = enableNotListed &&
            !propertiesToDisableNotListedCheckbox.includes(propertyName);
        return (_jsxs(Grid, { container: true, item: true, md: 12, lg: colCount, direction: 'column', spacing: 0.5, children: [_jsx(Grid, { item: true, children: _jsx(Overline, { color: color, children: propertyName }) }), _jsx(Grid, { translate: "no", container: true, item: true, spacing: 1, children: buttons }), _jsxs(Container, { container: true, item: true, columnSpacing: 1, rowSpacing: 0, children: [_jsxs(CheckboxContainer, { container: true, item: true, onClick: () => handleNotFound(propertyName), children: [_jsx(Grid, { item: true, children: _jsx(Checkbox, { checked: isNotFoundChecked }) }), _jsx(Grid, { item: true, children: _jsx(Text, { children: `${capitalizedName} not found on item` }) })] }), showNotListedCheckbox && _jsxs(CheckboxContainer, { container: true, item: true, onClick: () => handleNotListed(propertyName), children: [_jsx(Grid, { item: true, children: _jsx(Checkbox, { checked: isNotListedChecked }) }), _jsx(Grid, { item: true, children: _jsx(Text, { children: `${capitalizedName} not listed` }) })] })] }), errorMessage] }, propertyName));
    });
    return (_jsxs(Paper, { sx: { padding: '1.5rem' }, children: [_jsxs(Grid, { container: true, flexWrap: 'nowrap', spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(ImageWithZoom, { size: 'small', imageUrl: image, isZoomable: true, clickImageToZoom: true, showWhenNoPhotoAvailable: true }) }), _jsxs(Grid, { container: true, item: true, direction: 'column', justifyContent: 'space-evenly', children: [_jsx(SuperText, { color: 'text.secondary', children: superTitle }), _jsx(Title, { children: title }), _jsx(SubText, { color: 'text.secondary', children: subTitle })] })] }), _jsx(Divider, { sx: { marginY: '1.5rem' } }), _jsx(Grid, { container: true, spacing: 2, children: propertiesContent })] }));
};
export default PropertiesCard;
//# sourceMappingURL=index.js.map